<div class="px-3">
    <div class="row mb-3">
        <div class="col">
            <h2>
                <em class="fas fa-handshake pe-2"></em>
                {{ 'Lieferantenrahmenvertrag wählen' | translate }}
            </h2>
        </div>
        <div class="col-auto">
            <button mat-icon-button color="warn" (click)="cancel()">
                <em class="fas fa-times fa-1_5x"></em>
            </button>
        </div>
    </div>
    @if (data.options) {
    <div class="row mb-2">
        <div class="col">
            <ul class="list-group">
                @for (frameworkAgreement of data.options | orderBy: 'code'; track frameworkAgreement) {
                <li class="list-group-item hoverable cursor-pointer" (click)="save(frameworkAgreement)">
                    <div class="col">
                        <div class="row mx-auto align-items-center">
                            <strong class="m-0">{{ frameworkAgreement.agreementNumber }}</strong>
                        </div>
                    </div>
                </li>
                }
            </ul>
        </div>
    </div>
    }
    <div class="row justify-content-end sticky-buttons">
        <div class="col-md-auto col-sm-12 mb-1">
            <button class="btn btn-secondary w-100" (click)="cancel()">{{ 'Abbrechen' | translate }}</button>
        </div>
    </div>
</div>
